// Bookkeeping tasks are Other tasks whose type mentions "bookkeeping" -- there
// is no bookkeeping category in the database, so the Tasks page's Bookkeeping
// tab is a view over the Other tasks, split on this one rule. Changing a
// task's type moves it between the two tabs.

const BOOKKEEPING = /bookkeeping/i;

// `types` (the Other task types) is only consulted when the row carries a
// task_type id without its name.
export function isBookkeepingTask(task, types = []) {
  let name = task?.task_type_name;
  if (!name && task?.task_type != null) {
    name = (types.find((t) => t.id === task.task_type) || {}).name;
  }
  return BOOKKEEPING.test(name || "");
}

// What the Bookkeeping tab's new-task row starts its Type field on.
export const DEFAULT_BOOKKEEPING_TYPE = "Bookkeeping";
